/* react imports */

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Candidate from './pages/Candidate';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:id" element={<Candidate />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
